import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async enviarSugestao(axios, parametros) {   
    parametros.operacao = 'enviarSugestao';    

    let retorno = {};

    await axios.santriPOST('/rest/sugestao', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
  async buscarSugestao(axios) { 
    let parametros = {
      operacao: 'buscarSugestao'
    }

    let retorno = {};

    await axios.santriGET('/rest/sugestao', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno; 
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/RSugestao.js